module.exports = __webpack_public_path__ + "img/title-03.7e5dbae8.png";